export default __webpack_public_path__ + "static/media/main-clip.e88dc7ee.svg";